import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-active", "onDragenter", "onDragover", "onDragleave", "onDrop"]

import { ref, onMounted, onUnmounted } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'DropZone',
  emits: ["files-dropped"],
  setup(__props, { emit }) {

// make sure to import `ref` from Vue


// Create `active` state and manage it with functions
let active = ref(false);
let inActiveTimeout: number | undefined; // add a variable to hold the timeout key

function setActive() {
  active.value = true;
  clearTimeout(inActiveTimeout); // clear the timeout
}
function setInactive() {
  // wrap it in a `setTimeout`
  inActiveTimeout = setTimeout(() => {
    active.value = false;
  }, 50);
}
function onDrop(e: DragEvent) {
  setInactive(); // add this line too
  if (e.dataTransfer) {
    emit("files-dropped", [...e.dataTransfer.files]);
  }
}

function preventDefaults(e: { preventDefault: () => void }) {
  e.preventDefault();
}

const events = ["dragenter", "dragover", "dragleave", "drop"];

onMounted(() => {
  events.forEach((eventName) => {
    document.body.addEventListener(eventName, preventDefaults);
  });
});

onUnmounted(() => {
  events.forEach((eventName) => {
    document.body.removeEventListener(eventName, preventDefaults);
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    "data-active": _unref(active),
    onDragenter: _withModifiers(setActive, ["prevent"]),
    onDragover: _withModifiers(setActive, ["prevent"]),
    onDragleave: _withModifiers(setInactive, ["prevent"]),
    onDrop: _withModifiers(onDrop, ["prevent"])
  }, [
    _renderSlot(_ctx.$slots, "default", { dropZoneActive: _unref(active) })
  ], 40, _hoisted_1))
}
}

})